import { render, staticRenderFns } from "./createConstruction.vue?vue&type=template&id=27910e6f&scoped=true"
import script from "./createConstruction.vue?vue&type=script&lang=js"
export * from "./createConstruction.vue?vue&type=script&lang=js"
import style0 from "./createConstruction.vue?vue&type=style&index=0&id=27910e6f&prod&scoped=true&lang=css"
import style1 from "./createConstruction.vue?vue&type=style&index=1&id=27910e6f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27910e6f",
  null
  
)

export default component.exports